<template src="./html/Datatable.html"></template>

<script>
	import swal from 'sweetalert2'
	import Vuetable from 'vuetable-2/src/components/Vuetable'
	import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo'
	import VuetablePagination from 'vuetable-2/src/components/VuetablePagination'
	import FilterBar from './FilterBar'
	import ToolbarStatuses from './ToolbarStatuses.vue'
	import Export from './../../export/Export.vue'
	import Action from './Action.vue'
	import TasksMap from './TasksMap'
	import VueElementLoading from 'vue-element-loading'

	export default {
		props: ['user', 'isAuth', 'project'],
		components: {
			'datatable': Vuetable,
			'pagination-info': VuetablePaginationInfo,
			'pagination': VuetablePagination,
			'filter-bar': FilterBar,
			'toolbar-statuses': ToolbarStatuses,
			'export-component': Export,
			'action': Action,
			'tasks-map': TasksMap,
			'loading': VueElementLoading,
		},
		data () {
			return {
				showAction: false,
				perPages: [
					{
						label: 20,
						value: 20,
					},
					{
						label: 50,
						value: 50,
					},
					{
						label: 100,
						value: 100,
					},
					{
						label: 'Todo',
						value: null,
					},
				],
				dataExport: {
					url: 'admin/projects/tasks/export',
					show: false,
					status: null,
				},
				datatable: {
					api: this.$env.ROOT + '/api/' + this.$lang.getLang() + '/admin/projects/tasks/datatable',
					loading: true,
					moreParams: {
						filter: {
							allowDate: false,
							status: null,
							date: null,
							text: null,
							project_id: null,
							user_id: null,
						}
					},
					page: 20,
					path: '',
					sortOrder: [
						{
							field: 'created_at',
							sortField: 'created_at',
							direction: 'desc',
						}
					],
					options: {
						headers: {
							'Authorization': 'Bearer ' + this.$auth.getToken()
						}
					},
					css: {
						table: {
							sortableIcon: 'fa fa-sort',
							tableClass: 'table table-hover table-striped table-condensed',
							ascendingIcon: 'fa fa-caret-up',
							descendingIcon: 'fa fa-caret-down',
						},
						pagination: {
							wrapperClass: "pagination pull-right",
							activeClass: "btn-default disabled",
							disabledClass: "disabled",
							pageClass: "btn btn-default",
							linkClass: "btn btn-default",
							icons: {
								first: "fa fa-fast-backward",
								prev: "fa fa-step-backward",
								next: "fa fa-step-forward",
								last: "fa fa-fast-forward",
							}
						},
					},
					fields: [
						{
							name: '__checkbox',
							visible: false,
						},
						{
							name: '__slot:tasks_id',
							title: this.$platform.setting.number_symbol,
							sortField: 'id',
						},
						{
							name: '__slot:tasks_name',
							title: 'Nombre',
							sortField: 'name',
						},
						{
							name: '__slot:tasks_statuses',
							title: 'Estado',
						},
						{
							name: 'priority.name',
							title: 'Prioridad',
							sortField: 'priority_level_id',
						},
						{
							name: '__slot:tasks_users',
							title: 'Personal',
						},
						{
							name: '__slot:tasks_projects',
							title: 'Proyectos',
						},
						{
							name: '__slot:tasks_customers',
							title: 'Clientes',
						},
						/*
						{
							name: '__slot:tasks_workplaces',
							title: 'LOCALIZACIONES',
						},
						*/
						{
							name: '__slot:tasks_complete',
							title: 'Completada',
							sortField: 'completed',
						},
						{
							name: '__slot:tasks_schedules',
							title: 'Horario',
						},
						/*
						{
							name: '__slot:tasks_author',
							title: 'AUTHOR',
							sortField: 'author_id',
						},
						*/
						{
							name: 'created_at',
							title: 'Fecha',
							sortField: 'created_at',
							callback: function(value) {
								return moment(value).format('DD/MM/YY H:mm')
							},
						},
						{
							name: '__slot:tasks_actions',
							title: '',
						},
					],
				},
				tasks: null,
				status: null,
				statuses: null,
			}
		},
		watch: {
			'$route.params.status': function(value) {
				this.getStatus(value)
				if(value) {
					this.datatable.moreParams.filter.status = value
				} else {
					this.datatable.moreParams.filter.status = null
				}
				this.datatable.fields[0].visible = this.showCheckbox()

				this.$nextTick( () => this.$refs.datatable.normalizeFields())
				this.$nextTick( () => this.$refs.datatable.refresh())
			},
			'$i18n.locale'() {
				this.reload();
			}
		},
		created() {
			this.datatable.fields[0].visible = this.showCheckbox()
			if(this.$route.params.status) {
				this.datatable.moreParams.filter.status = this.$route.params.status
			}

			this.init()
		},
		methods: {
			init() {
				this.getStatus()
				this.getStatuses()
				this.getTasks()
				this.loadQuery()
				if(this.project) {
					this.datatable.moreParams.filter.project_id = this.project.id
				}
			},
			loadQuery() {
				if(this.$route.query) {
					if(this.$route.query.text) {
						this.datatable.moreParams.filter.text = this.$route.query.text
					}
					if(this.$route.query.date) {
						this.datatable.moreParams.filter.allowDate = true
						this.datatable.moreParams.filter.date = this.$route.query.date
					}
				}
			},
			getTasks() {
				if(this.$route.params.status) {
					var api = 'admin/projects/tasks/status/' + this.$route.params.status
				} else {
					var api = 'admin/projects/tasks'
				}
				this.$http.get(api)
				.then(response => {
					this.tasks = response.body
				})
			},
			reload() {
				this.$nextTick( () => this.$refs.datatable.refresh())
				this.getTasks()
				this.getStatus()
			},
			loading() {
				this.datatable.loading = true
			},
			loaded() {
				if(this.$refs.datatable.tableData.length) {
					this.dataExport.show = true
				} else {
					this.dataExport.show = false
				}
				this.datatable.loading = false

				$('[data-toggle="popover"]').popover()
			},
			onPaginationData (paginationData) {
				this.$refs.paginationInfo.setPaginationData(paginationData)
				this.$refs.pagination.setPaginationData(paginationData)
			},
			checkboxToggled() {
				if(this.$refs.datatable.selectedTo.length) {
					this.showAction = true
				} else {
					this.showAction = false
				}
				this.$refs.action.selected = this.$refs.datatable.selectedTo
			},
			onChangePage (page) {
				this.$refs.datatable.changePage(page)
			},
			filterSet() {
				this.$nextTick( () => this.$refs.datatable.refresh())
			},
			filterReset() {
				this.clearFilter()
				if(this.$refs.datatable) {
					this.$nextTick( () => this.$refs.datatable.refresh())
				}
			},
			clearFilter() {
				this.datatable.moreParams.filter.allowDate = false
				this.datatable.moreParams.filter.date = null
				this.datatable.moreParams.filter.text = null
				//this.datatable.moreParams.filter.project_id = null
				this.datatable.moreParams.filter.user_id = null
			},
			showCheckbox() {
				var status = this.$route.params.status
				return status == 'ended' || status == 'processing' || status == 'pending' || status == 'assigned'
			},
			lastTraceDate(traces) {
				return moment(traces[0].created_at).format('DD/MM/YY H:m:s')
			},
			canEdit (task) {
				var that = this

				if(!this.user.hasRole('admin')) {
					if(this.user.hasRole(['manager', 'external_manager'])) {
						if(task.projects) {
							if(task.projects.length) {
								var found = task.projects.find(function(project) {
									return project.user_id == that.user.id;
								});

								if(found) {
									return true
								}
							}
						}
					}
				} else {
					return true
				}

				return false
			},
			getStatus() {
				if(this.$route.params.status) {
					var slug = this.$route.params.status

					if(slug == 'completed') {
						this.status = null
					} else {
						this.$http.get('admin/projects/tasks/statuses/' + slug)
						.then(response => {
							this.status = response.body
						})
					}

				} else {
					this.status = null
				}
			},
			getStatuses() {
				this.$http.get('admin/projects/tasks/statuses')
				.then(response => {
					console.log(response)
					this.statuses = response.body
				})
			},
			dataContentPopoverSchedules(schedules) {
				var content = ''
				schedules.forEach(function(schedule) {
					content += moment(schedule.estimated_start).format('DD/MM/YY H:m') + ' - ' + moment(schedule.estimated_end).format('DD/MM/YY H:m') + '</br>'
				})
				return content
			},
			changeStatusTask: function(task) {
				var select = $(event.target)
				var status_id = event.target.value
				var data = {
					'task_id': task.id,
					'status_id': task.task_status_id,
				}

				if(status_id == 5) {
					if(task.auto_closing) {
						var that = this
						swal.queue([{
							title: this.$t("messages.attention"),
							text: "El auto cerrado está activado, se harán los cierres del personal y de los clientes",
							type: "warning",
							showCancelButton: true,
							confirmButtonColor: "#53e69d",
							cancelButtonColor: "#ff7676",
							confirmButtonText: "Si",
							cancelButtonText: "No",
							showLoaderOnConfirm: true,
							preConfirm: function () {
								return new Promise(function (resolve) {
									that.changeStatus(task, data)
								})
							}
						}]).catch(response => {
							select.val(task.status.id)
						})
					} else {
						this.changeStatus(task, data)
					}
				} else {
					this.changeStatus(task, data)
				}
			},
			changeStatus(task, data) {
				this.$http.post('admin/projects/tasks/status/change', data)
				.then(response => {
					task.task_status_id = response.body.data.task_status_id
					swal({
						title: response.body.title,
						text: response.body.text,
						type: response.body.type,
					})
					//this.$refs.datatable.reload()
				}).catch(function(response) {

					if(response.status == 409) {
						swal({
							title: response.body.title,
							text: response.body.text,
							type: response.body.type,
						})
					} else {
						swal({
							title: response.statusText,
							text: response.body,
							type: "warning"
						});
					}
				})
			},
			complete(task) {
				this.$http.get('admin/projects/tasks/'+task.id+'/complete')
					.then(response => {
						task.completed = response.body.completed
						task.task_status_id = response.body.task_status_id
					}).catch(function(response) {
						swal({
							title: response.statusText,
							text: response.body,
							type: "warning"
						});
					})
			},
			destroy(task) {
				var that = this

				var closing_users = task.closing_users
				var closing_customers = task.closing_customers

				var closing = closing_users.length + closing_customers.length

				if(closing) {
					swal({
						title: this.$t("messages.cant_deleted"),
						text: this.$t("messages.task_has_closures_of_users_clients"),
						type: "info"
					});
				} else {
					swal.queue([{
						title: this.$t("messages.attention"),
						text: this.$t("messages.item_can_not_be_retrieved"),
						type: "warning",
						showCancelButton: true,
						confirmButtonColor: "#53e69d",
						cancelButtonColor: "#ff7676",
						confirmButtonText: "Si",
						cancelButtonText: "No",
						showLoaderOnConfirm: true,
						preConfirm: function () {
							return new Promise(function (resolve) {
								that.$http.delete('admin/projects/tasks/' + task.id)
								.then(response => {
									that.$refs.datatable.reload()
									swal(response.body.title, response.body.text, response.body.type);
								}).catch(function(response) {
									swal({
										title: response.statusText,
										text: response.body,
										type: "warning"
									});
								})
							})
						}
					}]).catch(swal.noop)
				}
			},
		},
	}
</script>



// WEBPACK FOOTER //
// src/components/projects/tasks/views/Datatable.vue